import type * as React from 'react';
import { del } from '@Domain/Api';
import facilityTemplateOverrideRemoved, {
	type FacilityTemplateOverrideRemovedAction,
} from '@Application/Documents/TemplateAssignments/Actions/facilityTemplateOverrideRemoved';
import facilityTemplateOverrideRemoveFailed, {
	type FacilityTemplateOverrideRemoveFailedAction,
} from '@Application/Documents/TemplateAssignments/Actions/facilityTemplateOverrideRemoveFailed';
import type RemoveFacilityTemplateOverride from '@Application/Documents/TemplateAssignments/Commands/RemoveFacilityTemplateOverride';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = FacilityTemplateOverrideRemovedAction | FacilityTemplateOverrideRemoveFailedAction;

export default (command: RemoveFacilityTemplateOverride) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			await del<void>(
				`${parameters.api.host}/api/organizations/${command.organizationId}/facility-template-overrides/${command.overrideId}`,
			);

			const action = facilityTemplateOverrideRemoved({ overrideId: command.overrideId });
			dispatch(action);
			return action;
		} catch (error) {
			const action = facilityTemplateOverrideRemoveFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
